import { Emoji } from '@components/Emoji.tsx'
import { Link } from '@router'
import styles from './AppStub.module.css'

export const NotFound = () => (
	<main className={styles.screen}>
		<Link href="/" className={styles.back}>
			← Home
		</Link>
		<div className={styles.body}>
			<span className={styles.emoji}>
				<Emoji char="🤷" label="Shrug" />
			</span>
			<h1 className={styles.title}>Not found</h1>
			<p className={styles.hint}>This page doesn't exist yet.</p>
		</div>
	</main>
)
